export function isValidInternalPath(path?: string | null): path is string {
  if (!path || !path.startsWith('/')) return false;
  try {
    const { origin } = window.location;
    return new URL(path, origin).origin === origin;
  } catch {
    return false;
  }
}

export function getPostLoginRedirect(search: string): string | undefined {
  const params = new URLSearchParams(search);
  const redirect = params.get('redirect');
  return isValidInternalPath(redirect) ? redirect : undefined;
}
